<template>
    <el-dialog
        class="add"
        :visible.sync="externalLinksVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="800px"
        title="External Link"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
         <el-table :data="tableData" style="max-height:300px;overflow-y:auto">
            <el-table-column property="name" label="Name" width="150"></el-table-column>
            <el-table-column property="link" label="Link" width="120">
                <template slot-scope="scope">
                    <i class="el-icon-paperclip" style="font-size:14px;cursor:pointer" @click="links(scope.row.link)"></i>
                </template>
            </el-table-column>
            <el-table-column property="password" label="Password"></el-table-column>
            <el-table-column property="created_at" label="Created On"></el-table-column>
            <el-table-column label="Operation" width="150">
                <template slot-scope="scope">
                    <!-- <span style="padding-right:10px;cursor:pointer" @click="reset(scope.row.id)">Reset</span> -->
                    <el-popconfirm title="Are you sure reset"   style="padding-right:10px" @confirm="reset(scope.row.id)">
                        <el-button type="text" size="small" slot="reference">Reset</el-button>
                    </el-popconfirm> 
                    <el-popconfirm title="Are you sure delete？"  @confirm="del(scope.row.id)">
                        <el-button type="text" size="small" slot="reference" style="color:red">Delete</el-button>
                    </el-popconfirm>  
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >New External Link</el-button
            >
        </span>
        <createExternal :createExternalVisible.sync="createExternalVisible" :funcName="myfuncName"></createExternal>
    </el-dialog>
    
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import createExternal from "./createExternal";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            tableData: [],
            myfuncName: "getList",
            externalLinksVisible: false,
            createExternalVisible: false,
        };
    },
    methods: {
        save() {
            this.createExternalVisible = true; 
        },
        reset(id){
            this.loading = true;
            cmofferApi
                .externalReset( {id:id},"post")
                .then((res) => {
                    this.loading = false;
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.getList();
                });
        },
        getList(){
            cmofferApi
                .getExternalLinks({}, "post")
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                    }
                });
        },
        del(id){
            this.loading = true;
            cmofferApi
                .externalDel( {id:id},"post")
                .then((res) => {
                    this.loading = false;
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.getList();
                });
        },
        links(url){
             window.open(url, "_blank");
        },
        closeDialog() {
            this.addForm = {
                name: "",
            };
            this.$emit("update:externalLinksVisible", false);
        },

    },
    props: {
        externalLinksVisible: Boolean,
        funcName: String
    },
    components:{
        createExternal,
    },
    watch: {
        externalLinksVisible() {
            if (this.externalLinksVisible) {
                this.getList();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.add {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
